export const SIGN_UP = {
	RESET_TITLE: "Redefina sua senha",
	SEND_EMAIL: "Enviar e-mail",
	EMAIL_REQUIRED: "O email é obrigatório",
	SENDING: "Enviando...",
	EMAIL_SENT: "Email enviado com sucesso",
};